module.exports = __webpack_public_path__ + "static/media/carol.dea4d77e.png";